import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import './index.css'
import { Container, Row, Col } from 'reactstrap';



class Forms extends PureComponent {
  
    constructor(props) {
        super(props);
        this.state = {
            forms:[]
        };
    
    }


     componentDidMount() {
        this.getCustomFormList();
    }

    getCustomFormList() {
         const url = `${getLocationOrigin()}/form/list_all/`;
         const options = {...defaultOptions};

         fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({ forms:data.forms }))
           .catch(error => error);
    }

    render() {
        return(
            <div className="form_display">
                {this.state.forms && 
                    <Row className="form_label_row">
                        <Col md="1" className="form_label">Sl.No</Col>
                        <Col md="7" className="form_label">Title</Col>
                        <Col md="2" className="form_label">Responses</Col>
                        <Col md="2" className="form_label"></Col>  
                    </Row>
                }
                {this.state.forms &&this.state.forms.map((form,index)=>(
                    <Link to= {`/crud/form-response/${form.slug}`}>
                        <Row className="form_table">
                            <Col md="1">{index +1}</Col>
                            <Col md="7">{form.name}</Col>
                            <Col md="2">{form.response_count}</Col>
                            <Col md="2">View Details</Col>  
                        </Row>
                    </Link>
                ))}
            </div>
        );
    }
}

export default Forms;





// WEBPACK FOOTER //
// ./src/app/views/partner/crud/form/index.js